/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_TitleInputs */

const en_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend Development`)
};

const ar_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير الخلفية`)
};

const bn_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকএন্ড ডেভেলপমেন্ট`)
};

const de_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend-Entwicklung`)
};

const es_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo de back-end`)
};

const fr_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement backend`)
};

const pt_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento de back-end`)
};

const zh_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后端开发`)
};

const tr_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arka Uç Geliştirme`)
};

const ru_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бэкэнд-разработка`)
};

const pl_svc_backend_development_title = /** @type {(inputs: Svc_Backend_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwój backendu`)
};

/**
* | output |
* | --- |
* | "Backend Development" |
*
* @param {Svc_Backend_Development_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_title = /** @type {((inputs?: Svc_Backend_Development_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_title(inputs)
	if (locale === "bn") return bn_svc_backend_development_title(inputs)
	if (locale === "de") return de_svc_backend_development_title(inputs)
	if (locale === "es") return es_svc_backend_development_title(inputs)
	if (locale === "fr") return fr_svc_backend_development_title(inputs)
	if (locale === "pt") return pt_svc_backend_development_title(inputs)
	if (locale === "zh") return zh_svc_backend_development_title(inputs)
	if (locale === "tr") return tr_svc_backend_development_title(inputs)
	if (locale === "ru") return ru_svc_backend_development_title(inputs)
	if (locale === "pl") return pl_svc_backend_development_title(inputs)
	return en_svc_backend_development_title(inputs)
});
export { svc_backend_development_title as "svc_backend-development_title" }